import log from "loglevel";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { useEffect, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { download } from "assets";
import MarkdownPreview from '@uiw/react-markdown-preview';
import downloadFile from "Utils/downloadFile";
import { MdSkipNext, MdSkipPrevious } from "react-icons/md";
import { GoPaperclip } from "react-icons/go";
import { base_url } from "Constants";
import "@cyntler/react-doc-viewer/dist/index.css";
import { toast } from "react-toastify";
import { toastConfig } from 'Utils/DisplayGlobalMessage';

const supporttedExtensions = ['bmp', 'csv', 'odt', 'doc', 'docx', 'gif', 'htm', 'html', 'jpg', 'jpeg', 'pdf', 'png', 'ppt', 'pptx', 'tiff', 'txt', 'xls', 'xlsx'];


const DocumentView = ({ selectedSubSection }) => {
  // const docs = [
  //     { uri: "https://url-to-my-pdf.pdf" }, // Remote file
  //     // { uri: require("./example-files/pdf.pdf") }, // Local File
  // ];

  const [docUrl, setDocUrl] = useState(null);
  const [dmsg, setDmsg] = useState("loading");
  const [docTitle, setDocTitle] = useState(null);

  useEffect(() => {
    if (selectedSubSection && selectedSubSection.data && selectedSubSection.data.document_file) {
      setDocUrl(null);
      let doc_url = selectedSubSection.data.document_file;
      let redundant_info = "/media/bodhitree/elearning_academy/media/";
      log.log({ doc_url });
      if (doc_url.includes(redundant_info)) {
        doc_url = doc_url.replace(redundant_info, "/media/");
      }
      doc_url = `${base_url}${doc_url}`;
      const docPathArray = doc_url.split("/");
      const titleOfDoc = docPathArray[docPathArray.length - 1];
      if (titleOfDoc !== docTitle) {
        setDocTitle(titleOfDoc);
      }
      log.log({ doc_url, "": base_url });
      // setDocUrl([{ uri: doc_url }])
      setTimeout(() => setDocUrl([{ uri: doc_url }]), 3000);
    } else {
      // setDmsg("No document attached.");
      if (dmsg !== "") {
        setDmsg("");
      }
      setDocUrl(null);
    }
  }, [selectedSubSection]);

  // log.log({ DocumentView: selectedSubSection });
  // log.log(selectedSubSection?.data?.description)

  let docExtension = docTitle?.split(".");
  if (docExtension?.length > 1) {
    let lastIndex = docExtension.length - 1;
    docExtension = docExtension[lastIndex];
  } else {
    docExtension = "";
  }

  let isDocExtensionSupported = false;
  if (docExtension) {
    isDocExtensionSupported = supporttedExtensions?.filter(a => a === docExtension).length === 1;
  }

  const handleFileDownload = (fileUrl) => {
    // Show loading toast when download starts
    const toastId = toast.loading(
      "Downloading...",
      toastConfig
    );

    // Call the downloadFile function
    downloadFile(fileUrl)
      .then(() => {
        // Update toast on successful download initiation
        toast.update(toastId, {
          render: "Download started successfully!",
          type: "success",
          autoClose: 3000,
          closeOnClick: true,
          draggable: true,
          hideProgressBar: false,
          isLoading: false
        });
      })
      .catch(() => {
        // The downloadFile function already shows error messages
        // Just dismiss the loading toast
        toast.dismiss(toastId);
      });
  };

  return (
    <>
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-start">
        <h5
          className="text-primary mb-0"
          style={{ wordBreak: 'break-word', overflowWrap: 'anywhere', flex: '1 1 auto', minWidth: 0, marginRight: 12 }}
        >
          {selectedSubSection?.data?.title} (Document)
        </h5>
        {
          docUrl ?
            // <div className="d-flex justify-content-end align-items-end mt-2 mt-md-0">
            //   <div className="d-flex align-items-center" style={{ gap: 20, border: "1px solid #cecece", padding: 10, borderRadius: 10 }}>
            //     <div className="mb-0 text-monospace d-flex align-items-center">
            //       <GoPaperclip />
            //       <small className="ml-2">(File: {docTitle})</small>
            //     </div>
            //     <Button size="sm" onClick={() => downloadFile(docUrl)}>
            //       <img src={download} alt="" style={{ width: 15, height: 15 }} />
            //       <span><b>Download Document</b></span>
            //     </Button>
            //   </div>
            // </div>
            <>
              {/* Desktop version - original design */}
              <div className="d-none d-md-flex justify-content-end align-items-end">
                <div className="d-flex align-items-center" style={{ gap: 20, border: "1px solid #cecece", padding: 10, borderRadius: 10 }}>
                  <div className="mb-0 text-monospace d-flex align-items-center">
                    <GoPaperclip />
                    <small className="ml-2">(File: {docTitle})</small>
                  </div>
                  <Button
                    size="sm"
                    onClick={() => handleFileDownload(docUrl)}
                    style={{ whiteSpace: 'nowrap', flexShrink: 0 }}
                  >
                    <img src={download} alt="" style={{ width: 15, height: 15 }} />
                    <span><b>Download</b></span>
                  </Button>
                </div>
              </div>

              {/* Mobile version - with file info */}
              <div className="d-flex d-md-none align-items-center justify-content-between mt-3" style={{ width: '100%' }}>
                <div className="text-monospace d-flex align-items-center">
                  <GoPaperclip />
                  <small className="ml-2 text-wrap text-truncate" style={{ maxWidth: '250px' }}>(File: {docTitle})</small>
                </div>
                <Button
                  size="sm"
                  onClick={() => handleFileDownload(docUrl)}
                  className="ml-3"
                  style={{ whiteSpace: 'nowrap', flexShrink: 0 }}
                >
                  <img src={download} alt="" style={{ width: 20, height: 20 }} />
                  <span><b>Download</b></span>
                </Button>
              </div>
            </>
            : <></>
        }
      </div>
      <div className="py-2 px-0  markdown-preview-container">
        <MarkdownPreview
          source={selectedSubSection.data.description}
          style={{ overflow: 'hidden', maxWidth: '100%' }}
          skipHtml={false}
        />
      </div>
      {docUrl ? <>
        <div className="d-flex flex-column">
          <div style={{ boxShadow: "1px 1px 5px gray", marginTop: 15 }}>
            {log.log({ docExtension, supporttedExtensions, isDocExtensionSupported })}
            {
              !isDocExtensionSupported ?
                <>
                  {/* <div className="d-flex justify-content-center align-items-center w-100" style={{ height: "30vh" }}>
                    <p className="mb-0 text-muted text-center">
                      We don't support this format yet.
                      <br />
                      Please download it to view on your local machine.
                    </p>
                  </div> */}
                  <div></div>
                </> : <>
                  <div
                    // style={{
                    //   height: "90vh",
                    //   maxHeight: "calc(100vh-120px)",

                    // }}
                    className="doc-viewer-container"
                  >
                    <DocViewer
                      documents={docUrl}
                      pluginRenderers={DocViewerRenderers}
                      style={{
                        height: "100%", backgroundColor: "gray", overflow: "auto",

                      }}
                      config={{
                        header: {
                          // overrideComponent: MyHeader,
                        },
                        pdfZoom: {
                          defaultZoom: window.innerWidth < 768 ? 1.2 : 0.8, // Smaller default zoom on mobile
                          zoomJump: 0.2
                        },
                        pdfVerticalScrollByDefault: true
                      }}
                    />
                  </div>
                  {
                    docExtension?.includes?.('ppt') ? <p className="text-muted text-center my-1">"Space Bar" moves ahead in ppt with animations and clicking on next (▶) above skips animation.</p> : <></>
                  }
                </>
            }
          </div>
        </div>
      </> : <>
        {dmsg === 'loading' ?
          <div className="d-flex justify-content-center align-items-center flex-column" style={{ minHeight: "40vh" }}>
            <Spinner animation="border" />
          </div> : <h6 className="text-muted text-center"><em>{dmsg}</em></h6>}
      </>}
    </>
  );
};

const MyHeader = (state, previousDocument, nextDocument) => {
  if (!state.currentDocument || state.config?.header?.disableFileName) {
    return null;
  }

  return (
    <>
      <div className="bg-white d-flex justify-content-between align-items-center p-3" style={{ borderBottom: "1px solid gray", zIndex: 9 }} >
        <div>
          {/* {state.currentDocument.uri || ""} */}
        </div>
        <div className="d-flex" style={{ gap: 10 }}>
          <div className="shadow p-2 cursor-pointer" style={{ borderRadius: 5 }}
            onClick={previousDocument}
            disabled={state.currentFileNo === 0}
          >
            <MdSkipPrevious className="mr-2" /> Document
          </div>
          <div
            className="shadow p-2 cursor-pointer" style={{ borderRadius: 5 }}
            onClick={nextDocument}
            disabled={state.currentFileNo >= state.documents.length - 1}
          >
            <MdSkipNext className="mr-2" /> Document
          </div>
        </div>
      </div>
    </>
  );
};

export default DocumentView;
